import { Application } from "@hotwired/stimulus"
import { register as registerTurboOverlay } from "turbo_overlay"

const application = Application.start()

// Same overlay system as the portal bundle; the Bootstrap 3 look comes from the
// chrome partials ApplicationController prepends, not from the JS.
registerTurboOverlay(application, { confirm: true })

import ProductSearchController from "./product_search_controller"
import OrganizationSearchController from "./organization_search_controller"
import FavoriteStarController from "./favorite_star_controller"
import ArticleToggleController from "./article_toggle_controller"
import TranslationEditorController from "./translation_editor_controller"
import ProductManagementController from "./product_management_controller"
import EnhancementController from "./enhancement_controller"
import SearchHighlightController from "./search_highlight_controller"
import FilePreviewController from "./file_preview_controller"
import LanguageSelectorController from "./language_selector_controller"
import EmbedOverlayController from "./embed_overlay_controller"
import ScrollToEndController from "../shared_scroll_to_end_controller"
import ToastController from "../shared_toast_controller"
import StreamPollController from "../shared_stream_poll_controller"
import TooltipPopoverController from "./tooltip_popover_controller"
import DownloadSpinnerController from "./download_spinner_controller"
import AdminMenuController from "./admin_menu_controller"
import SortableController from "./sortable_controller"
import MassUpdateController from "./mass_update_controller"
import ReassignAllController from "./reassign_all_controller"
import LockedOverrideController from "./locked_override_controller"
import NotificationToggleController from "./notification_toggle_controller"
import RemoteSubmitController from "./remote_submit_controller"
import BookmarkController from "./bookmark_controller"
import ActivateVersionController from "./activate_version_controller"
import DefaultUrlController from "./default_url_controller"
import ContactStatusController from "./contact_status_controller"
import VersionFilterController from "./version_filter_controller"
import FavoritedStatusController from "./favorited_status_controller"
import InlineEditController from "./inline_edit_controller"
import ContactToggleController from "./contact_toggle_controller"
import BulkFormController from "./bulk_form_controller"
import TermsOfUsageFormController from "./terms_of_usage_form_controller"
import RichTextEditorController from "./rich_text_editor_controller"
import TaskFormController from "./task_form_controller"
import SignaturePadController from "./signature_pad_controller"
import ClipboardController from "./clipboard_controller"
import LockboxEntryController from "./lockbox_entry_controller"
import MembershipCatalogPrefillController from "./membership_catalog_prefill_controller"
import DirectUploadController from "./direct_upload_controller"
import BackgroundSearchPollController from "./background_search_poll_controller"

application.register("product-search", ProductSearchController)
application.register("organization-search", OrganizationSearchController)
application.register("favorite-star", FavoriteStarController)
application.register("article-toggle", ArticleToggleController)
application.register("translation-editor", TranslationEditorController)
application.register("product-management", ProductManagementController)
application.register("enhancement", EnhancementController)
application.register("search-highlight", SearchHighlightController)
application.register("file-preview", FilePreviewController)
application.register("language-selector", LanguageSelectorController)
application.register("embed-overlay", EmbedOverlayController)
application.register("tooltip-popover", TooltipPopoverController)
application.register("download-spinner", DownloadSpinnerController)
application.register("admin-menu", AdminMenuController)
application.register("sortable", SortableController)
application.register("mass-update", MassUpdateController)
application.register("reassign-all", ReassignAllController)
application.register("locked-override", LockedOverrideController)
application.register("notification-toggle", NotificationToggleController)
application.register("remote-submit", RemoteSubmitController)
application.register("bookmark", BookmarkController)
application.register("activate-version", ActivateVersionController)
application.register("default-url", DefaultUrlController)
application.register("contact-status", ContactStatusController)
application.register("version-filter", VersionFilterController)
application.register("favorited-status", FavoritedStatusController)
application.register("inline-edit", InlineEditController)
application.register("contact-toggle", ContactToggleController)
application.register("bulk-form", BulkFormController)
application.register("terms-of-usage-form", TermsOfUsageFormController)
application.register("rich-text-editor", RichTextEditorController)
application.register("task-form", TaskFormController)
application.register("signature-pad", SignaturePadController)
application.register("clipboard", ClipboardController)
application.register("lockbox-entry", LockboxEntryController)
application.register("membership-catalog-prefill", MembershipCatalogPrefillController)
application.register("direct-upload", DirectUploadController)
application.register("background-search-poll", BackgroundSearchPollController)
application.register("scroll-to-end", ScrollToEndController)
application.register("toast", ToastController)
application.register("stream-poll", StreamPollController)

export { application }
